<template>
  <div class="OrderDetailTabContainer" id="buddhist">
    <br />
    <!-- 梵字 or 家紋 -->
    <div class="characterGroup-Form">
      <!-- 梵字 or 家紋 -->
      <label class="FormGroup-Label">1. 梵字・家紋</label>
      <div class="FormGroup-Form" id="characterOptionButton">
        <el-select
          placeholder="選択"
          @change="_onClickCharacterOptionButton($event)"
          :value="form.sanskritCharacterOrFamilyEmblem"
        >
          <el-option
            v-for="option in sanskritCharacterOrFamilyEmblemOptions"
            :key="option.label"
            :label="option.label"
            :value="option.value"
            :disabled="option.value === 'FAMILY_EMBLEM' && isMindAlte"
          >
            {{ option.label }}</el-option
          >
        </el-select>
        <div
          class="characherCard-Form"
          style="margin: 0 -10px 0 0px;"
          v-if="form.sanskritCharacterOrFamilyEmblem === 'SANSKRIT_CHARACTER'"
        >
          <div class="FormGroup" style="margin-top: 0rem;">
            <label class="FormGroup-Label"></label>
            <div class="FormGroup-Form u-mt20">
              <el-button
                class="choseDefaultButton"
                @click="onClickOpenSanskritCharacterModal"
                type="primary"
                >梵字画像から選択</el-button
              >

              <!-- 梵字アップローダ -->
              <el-upload
                class="AddAttachmentButton"
                ref="uploadSanskritCharacter"
                action
                :auto-upload="false"
                :on-change="_onChangeSanskritCharacter"
                accept=".jpg, .png"
                :show-file-list="false"
                :multiple="false"
              >
                <el-button class="DirectUploadButton" type="primary"
                  >直接画像を選択</el-button
                >
              </el-upload>

              <!-- 梵字ダイアログ -->
              <el-dialog
                title="梵字選択"
                :visible.sync="sanskritCharacterDialogVisible"
                width="90%"
                top="1vh"
              >
                <div class="characterCardWrapper">
                  <GridContainer :column="4">
                    <CharacterCard
                      v-for="item in sanskritCharacters"
                      :key="item.id"
                      :data="item.id"
                      :isActive="
                        form.sanskritCharacter &&
                        form.sanskritCharacter.id === item.id
                      "
                      @click="_onClickSanskritCharacterCard(item)"
                      :text="item.sect"
                      :image="item.imageUrl"
                    />
                  </GridContainer>
                </div>
              </el-dialog>
            </div>
            <div />
          </div>

          <div class="FormGroup u-mt10 u-ml50" v-if="isCustomSanskritCharacter">
            <label class="FormGroup-Label">梵字の画像</label>
            <div class="FormGroup-Form FormGroup-Form--LeftAlign">
              <img
                class="CustomSanskritCharacterPreview"
                :src="customSanskritCharacterImg"
                alt=""
              />
            </div>
          </div>
        </div>

        <!-- 家紋を選択 -->
        <div
          v-if="form.sanskritCharacterOrFamilyEmblem === 'FAMILY_EMBLEM'"
          class="characherCard-Form"
          style="margin: 0 -10px 0 0px;"
        >
          <div class="FormGroup" style="margin-top: 0rem;">
            <label class="FormGroup-Label"></label>
            <div class="FormGroup-Form u-mt20">
              <el-button
                class="choseDefaultButton"
                @click="onClickOpenKamonModal"
                type="primary"
                >家紋画像から選択</el-button
              >

              <!-- 家紋アップローダ -->
              <el-upload
                class="AddAttachmentButton"
                ref="uploadFamilyEmblem"
                action
                :auto-upload="false"
                :on-change="_onChangeFamilyEmblemFile"
                accept=".jpg, .png"
                :show-file-list="false"
                :multiple="false"
              >
                <el-button class="DirectUploadButton" type="primary"
                  >直接画像を選択</el-button
                >
              </el-upload>

              <!-- 家紋ダイアログ -->
              <el-dialog
                v-if="kamonDialogVisible"
                title="家紋選択"
                :visible.sync="kamonDialogVisible"
                width="90%"
                top="1vh"
              >
                <div class="Step1" v-if="!kamonForm.char">
                  <div
                    class="CharRow"
                    v-for="(chars, columnIndex) in aiueo"
                    :key="columnIndex"
                  >
                    <button
                      class="CharCard"
                      v-for="(char, rowIndex) in chars"
                      v-bind:key="`CharCard${rowIndex}`"
                      :disabled="familyEmblemIsExistList[columnIndex][rowIndex] === false"
                      @click="onClickChar(char)"
                    >
                      {{ char }}
                    </button>
                  </div>
                </div>

                <div
                  class="Step2"
                  v-if="kamonForm.char && !kamonForm.familyEmblemType"
                >
                  <div class="CharRow">
                    <p v-if="!familyEmblemTypes.length">
                      {{ kamonForm.char }} から始まる家紋が一つもありません
                    </p>
                    <div
                      class="CharCard"
                      v-for="(familyEmblemType, index) in familyEmblemTypes"
                      :key="index"
                      @click="onClickKamonType(familyEmblemType)"
                    >
                      <p class="CharCardInner">
                        {{ familyEmblemType.name }}<br />
                        <span class="CharKana"
                          >({{ familyEmblemType.nameKana }})</span
                        >
                      </p>
                    </div>
                  </div>
                </div>

                <div class="Step3" v-if="kamonForm.familyEmblemType">
                  <div class="CharRow">
                    <div
                      class="CharCard"
                      v-for="(familyEmblem, index) in kamonForm.familyEmblemType
                        .familyEmblems"
                      :key="index"
                      @click="onCLickKamon(familyEmblem)"
                    >
                      <img :src="familyEmblem.imageUrl" alt="" />
                      <div style="text-align:center">
                        <span>
                          {{ familyEmblem.name }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <span slot="footer" class="dialog-footer">
                  <el-button
                    v-if="kamonForm.char"
                    @click="kamonForm = { char: '', familyEmblemType: null }"
                    >戻る</el-button
                  >
                </span>
              </el-dialog>
            </div>
          </div>
        </div>
      </div>

      <!-- 梵字を選択 -->

      <div class="u-line u-line--dashed" />
    </div>
    <!-- 霊ごとの設定 -->
    <label class="FormGroup-Label">2. 戒名</label>
    <div v-if="form.columns.length">
      <div
        class="Columns FormGroup-Form u-mt10 Buddhist-Name-Input"
        v-for="(column, index) in form.columns"
        :key="index"
      >
        <div class="subLabelBuddhistName">
          <label class="Columns-IndexLabel">{{ index + 1 }}霊目</label>
        </div>
        <div v-if="layoutObj.type === '通常位牌' || layoutObj.type === 'マインドアルテ'">
          <RestrictedCharacterInput
            style="transform: none;width: 100%;"
            label="戒名"
            class="Buddhist-Name-Input-Column"
            :value="$itaijiFM.getText(column.buddhistName)"
            pattern="IHAI_INPUT_PATTERN"
            @onChangeInput="_onChangeBuddhistName($event, index)"
            @onSubmit="_onChangeBuddhistName($event, index)"
          />
        </div>
      </div>
    </div>
    <!-- 位表記-->
    <div class="FormGroup-Form" id="underCharacterPlacementButton">
      <div class="subLabelUnderCharacter">
        <label class="Columns-IndexLabel">位表記</label>
      </div>
      <!-- 位表記位置-->
      <div class="FormGroup-Form">
        <ButtonGroup>
          <el-select
            style="margin-top: 10px;"
            placeholder="選択"
            @change="_onClickUnderCharacterPlacementButton($event)"
            :value="form.underCharactersPlacement"
          >
            <el-option
              v-for="option in underCharactersPlacement"
              :key="option.label"
              :label="option.label"
              :value="option.value"
            >
              {{ option.label }}</el-option
            >
          </el-select>
        </ButtonGroup>
      </div>
      <!-- 位表記文字-->
      <div
        class="underCharacterCenter"
        v-if="form.underCharactersPlacement !== ''"
      >
        <div class="FormGroup" style="  margin-top: 0rem;">
          <label class="FormGroup-Label"></label>
          <div class="FormGroup-Form">
            <el-select
              placeholder="選択"
              @change="_onClickSanskritOptionButton($event)"
              :value="$itaijiFM.getText(form.underCharacters)"
            >
              <el-option
                v-for="option in underCharacters"
                :key="option.label"
                :label="option.label"
                :value="option.value"
              >
                {{ option.label }}</el-option
              >
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="u-line u-line--dashed" />
  </div>
</template>

<script>
import { produce } from "immer";
import { mapState, mapGetters } from "vuex";

// Data Handler
import EntityFactory from "@/entities/entity.factory";
// import { BuddhistName } from "@/entities/order.entity";

import SAMPLE_URL from "../const/samplePictUrl.js";

// Components
import ButtonGroup from "@/components/ButtonGroup";
import CharacterCard from "@/components/CharacterCard";
import GridContainer from "@/components/GridContainer";
import RestrictedCharacterInput from "@/components/RestrictedCharacterInput";

// Usecases
import FileUsecase from "@/usecases/file.usecase";
// import OrderFormUsecase from "@/usecases/orderForm.usecase";
import SanskritCharacterUsecase from "@/usecases/sanskritcharacter.usecase";

// Services
import ServiceFactory from "@/services/service.factory";

const orderOption = EntityFactory.create("orderOption");

const familyEmblemService = ServiceFactory.create("familyEmblem");

const aiueo = [
  "あいうえお".split(""),
  "かきくけこ".split(""),
  "さしすせそ".split(""),
  "たちつてと".split(""),
  "なにぬねの".split(""),
  "はひふへほ".split(""),
  "まみむめも".split(""),
  "やゆよ".split(""),
  "らりるれろ".split(""),
  "わをん".split(""),
];

const aiueoList = [
  "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわをん".split(
    ""
  ),
];

const aiueoLength = aiueoList.length;

export default {
  components: {
    ButtonGroup,
    CharacterCard,
    GridContainer,
    RestrictedCharacterInput,
  },
  data () {
    return {
      addOrNot: orderOption.addOrNot,
      includedOrNot: orderOption.includedOrNot,
      sects: orderOption.sects,
      sanskritCharacters: [],
      isCustomFamilyEmblem: false,
      isCustomSanskritCharacter: false,
      customFamilyEmblemImg: "",
      customSanskritCharacterImg: "",
      sanskritCharacterOrFamilyEmblemOptions: orderOption.sanskritCharacterOrFamilyEmblem,
      selectedButton: "",
      showCharacterCards: false,
      showFamilyCrestNameForm: false,
      popularLayoutName: "俗名位牌",
      underCharacters: orderOption.underCharacters,
      activeEditorIndex: null,
      kamonDialogVisible: false,
      sanskritCharacterDialogVisible: false,
      sanskritCharacterCards: false,
      aiueo,
      aiueoList,
      aiueoLength,
      kamonForm: {
        char: "",
        familyEmblemType: null,
      },
      familyEmblemTypes: [],
      familyEmblemsList: [],
      familyEmblemIsExist: false,
      familyEmblemIsExistList: [],
      font: this.$store.state.orderForm.typographyInput.font,
      underCharactersPlacement: orderOption.underCharactersPlacement,
      secularNamePrefixPlacement: orderOption.secularNamePrefixPlacement,
      ageAtDeathPrefixPlacement: orderOption.ageAtDeathPrefixPlacement,
    };
  },
  computed: {
    ...mapState({
      orderType: state => state.orderForm.orderTypeInput,
    }),
    ...mapGetters({
      detail: "orderForm/orderDetail",
      filteredFavoriteVariantCharacters: "orderForm/getFilteredFavoriteVariantCharacters",
      isMindAlte: "orderForm/isMindAlte",
    }),
    layoutObj: {
      get () {
        this.previewOrder();
        return this.$store.state.orderForm.orderTypeInput;
      },
    },
    form: {
      get () {
        return this.$store.state.orderForm.detailInput;
      },
      set (value) {
        this.$store.commit("orderForm/setDetail", { ...value });
      },
    },
  },
  async created () {
    await this.previewOrder();
    await this.getFamilyEmblems();

    const charactersResult = await usecase.sanskritCharacter.getSanskritCharacters();
    this.sanskritCharacters = charactersResult.data.sanskritCharacters;
    const sanskritCharacterOrFamilyEmblem = this.form
      .sanskritCharacterOrFamilyEmblem;

    if (sanskritCharacterOrFamilyEmblem === "SANSKRIT_CHARACTER") {
      if (this.form.customSanskritCharacterUrl === null) {
        this.sanskritCharacterCards = true;
      }
    }

    // 以下の意図がよく分からない
    // const orderTypeInput = this.orderType.type;
    // if (orderTypeInput === this.popularLayoutName) {
    //   this.form.sanskritCharacterOrFamilyEmblem = "NO_NEED";
    //   this.form.sanskritCharacter = null;
    //   this.form.familyEmblem = {
    //     name: "",
    //     imageUrl: ""
    //   };
    // }

    // TODO: it doesn't work now so I commented out, however it should be recovered in the future
    // var orderTypeInput = this.orderType.type;
    // if (orderTypeInput === this.popular) {
    //   this.selectedButton = "いれない";
    //   // this._onClickCharacterOptionButton(this.selectedButton);
    // } else {
    //   if (
    //     this.form.sanskritCharacter.isNeeded === false &&
    //     this.form.familyEmblem.name === ""
    //   ) {
    //     this.selectedButton = "いれない";
    //   }
    // }
    // if (this.form.familyEmblem.name !== "") {
    //   this.selectedButton = "家紋";
    // }
    // if (this.form.sanskritCharacter.sect !== "") {
    //   this.selectedButton = "梵字";
    // }
  },
  mounted () {
    // 1霊の場合は位表記の選択肢から「霊ごと」を削除する
    if (this.form.columns.length === 1) {
      this.underCharactersPlacement = this.underCharactersPlacement.filter(
        p => p.value !== "EACH_COLUMN"
      );
    }
  },
  methods: {
    // When you tap the 中央or霊ごと
    _onClickUnderCharacterPlacementButton (value) {
      this.form = { ...this.form, ...{ underCharactersPlacement: value } };
      if (value === "") {
        this.form.underCharacters = [];
      }
    },
    _onClickSanskritOptionButton (underCharacters) {
      const { toItaiji } = this.$itaijiFM;
      this.form = produce(this.form, d => {
        d.underCharacters = toItaiji(underCharacters, this.filteredFavoriteVariantCharacters);
      });
    },

    async previewOrder () {
      if (this.form.customFamilyEmblemUrl) {
        this.isCustomFamilyEmblem = await true;
        this.form.familyEmblem = await {
          familyEmblemId: "uploadImg",
          imageUrl: SAMPLE_URL.URLHead + SAMPLE_URL.FAMILY_EMBLEM, // constファイル作ってここに直打ち
          name: "ユーザー選択画像",
        };
        this.customFamilyEmblemImg = await usecase.file.fetchURL(
          this.form.customFamilyEmblemUrl
        );
        this.isCustomFamilyEmblem = true;
      }
      if (this.form.customSanskritCharacterUrl) {
        this.isCustomSanskritCharacter = await true;
        this.sanskritCharacterCards = await false;
        this.form.sanskritCharacter = await {
          id: "uploadImg",
          sect: "ユーザー選択画像",
          imageUrl: SAMPLE_URL.URLHead + SAMPLE_URL.SANSKRIT_CHARACTER, // constファイル作ってここに直打ち
          inputCode: "",
          imageUrlForTablet: SAMPLE_URL.URLHead + SAMPLE_URL.SANSKRIT_CHARACTER, // constファイル作ってここに直打ち
        };

        this.customSanskritCharacterImg = await usecase.file.fetchURL(
          this.form.customSanskritCharacterUrl
        );
        this.isCustomSanskritCharacter = true;
      }

      // 梵字 . 家紋の「入れない」「梵字」の選択時のユーザーの選択情報の復帰処理
      const sanskritCharacterOrFamilyEmblem = this.form
        .sanskritCharacterOrFamilyEmblem;

      if (sanskritCharacterOrFamilyEmblem === "SANSKRIT_CHARACTER") {
        if (this.form.customSanskritCharacterUrl === null) {
          this.sanskritCharacterCards = true;
        }
      }
    },
    removeFile (file, fileList) {
      this.images = [];
      for (let i = 0; i < fileList.length; i++) {
        this.images.push(fileList[i].name);
      }
    },
    async getFamilyEmblems () {
      // 選択書体で検索する。未対応書体の寄せは familyEmblem.service 側で行う
      const options = {
        q: {
          font: this.font,
          nameKanaPrefix: null,
        },
      };
      const familyEmblemsList = await familyEmblemService.find(options);
      this.familyEmblemsList = familyEmblemsList;
      let familyEmblemInitials = []; // 家紋の頭文字を格納するリスト
      const aiueoList = []; // 五十音を取り出すリスト
      for (let i = 0; i < this.familyEmblemsList.length; i++) {
        const initial = this.familyEmblemsList[i].nameKana.slice(0, 1);
        // 取得したイニシャルにnormalizeをかけて濁音と半濁音を消して格納
        familyEmblemInitials.push(initial.normalize("NFD")[0]);
      }
      for (let j = 0; j < this.aiueo.length; j++) {
        // 二次元配列を一次元に戻す
        for (let k = 0; k < this.aiueo[j].length; k++) {
          aiueoList.push(this.aiueo[j][k]);
        }
      }
      // 家紋の頭文字配列から重複を削除
      familyEmblemInitials = Array.from(new Set(familyEmblemInitials));
      // 多次元配列でまとめるやつ
      for (let indexCount = 0; indexCount < 10; indexCount++) {
        let oneColumnList = [];
        for (
          let charCount = 0;
          charCount < aiueo[indexCount].length;
          charCount++
        ) {
          if (
            familyEmblemInitials.indexOf(aiueo[indexCount][charCount]) !== -1
          ) {
            await oneColumnList.splice(charCount, 0, true);
          } else {
            await oneColumnList.splice(charCount, 0, false);
          }
        }
        this.familyEmblemIsExistList.push(oneColumnList);
      }
    },
    // When you tap the 梵字or家紋
    _onClickCharacterOptionButton (sanskritCharacterOrFamilyEmblem) {
      this.form = { ...this.form, sanskritCharacterOrFamilyEmblem };
      /*
       this.form.sanskritCharacter =
        sanskritCharacterOrFamilyEmblem === "SANSKRIT_CHARACTER"
        ? this.form.sanskritCharacter
        : null;
      this.form.familyEmblem =
        sanskritCharacterOrFamilyEmblem === "FAMILY_EMBLEM"
          ? this.form.familyEmblem
          : { name: "", imageUrl: "" };
       */
    },
    // When you click 梵字
    _onClickSanskritCharacterCard (sanskritCharacter) {
      // カスタム梵字が入っている場合nullにする
      this.form.customSanskritCharacterUrl = null;
      // カスタム家紋が入っている場合nullにする
      this.form.customFamilyEmblemUrl = null;
      this.form = { ...this.form, sanskritCharacter: { ...sanskritCharacter } };
      this.sanskritCharacterDialogVisible = false;
    },
    _onChangeFamilyEmblemName (name) {
      const { familyEmblem } = this.form;
      familyEmblem.name = name;
      this.form = { ...this.form, familyEmblem };
    },
    // _onClickSanskritOptionButton (underCharacters, index) {
    //   const { toItaiji } = this.$itaijiFM;
    //   this.form = produce(this.form, d => {
    //     d.columns[index].underCharacters = toItaiji(underCharacters, this.filteredFavoriteVariantCharacters);
    //   });
    // },
    _onChangeBuddhistName (buddhistName, index) {
      const { toItaiji } = this.$itaijiFM;
      this.form = produce(this.form, d => {
        d.columns[index].buddhistName = toItaiji(buddhistName, this.filteredFavoriteVariantCharacters);
      });
    },

    /**
     * [_onChangeFamilyEmblemFile description]
     * @param   {[type]}  file  [file description]
     * @return  {[type]}        [return description]
     */
    async _onChangeFamilyEmblemFile (file) {
      const { raw, name } = file;

      // アップロード時のファイルサイズ制限
      // 元々指定がなかっため max: 5GB までのファイルを扱う
      if (!usecase.file.validateFileSize(file, "max")) {
        // Clear file list
        this.$refs.uploadFamilyEmblem.clearFiles();

        return;
      }

      // 保存する画像のカテゴリを分ける
      const category = "familyEmblem";

      try {
        const fileName = usecase.file.fetchFileName(name, category);

        const result = await usecase.file.uploadFile(fileName, raw);

        const customFamilyEmblemUrl = result.key;

        // file.serviceで画像を取得。aws上のトークンつき画像URLをソースとし表示
        this.customFamilyEmblemImg = await usecase.file.fetchURL(result.key);

        this.form.familyEmblem = {
          familyEmblemId: "uploadImg",
          imageUrl: SAMPLE_URL.URLHead + SAMPLE_URL.FAMILY_EMBLEM, // constファイル作ってここに直打ち
          name: "ユーザー選択画像",
        };

        this.form = {
          ...this.form,
          customFamilyEmblemUrl,
        };

        // カスタム家紋を有効化
        this.isCustomFamilyEmblem = true;

        // カスタム家紋選択時、カスタム梵字のURLをnullにする
        this.form.customSanskritCharacterUrl = null;
      } catch (err) {
        console.log(err);

        // Clear file list
        this.$refs.uploadFamilyEmblem.clearFiles();
      }
    },
    async _onChangeSanskritCharacter (file) {
      const { raw, name } = file;

      // アップロード時のファイルサイズ制限
      // 元々指定がなかっため max = 5GB までのファイルを扱う
      if (!usecase.file.validateFileSize(file, "max")) {
        // Clear file list
        this.$refs.uploadSanskritCharacter.clearFiles();

        return;
      }

      // 保存する画像のカテゴリを分ける
      const category = "sanskritCharacter";

      try {
        const fileName = usecase.file.fetchFileName(name, category);

        const result = await usecase.file.uploadFile(fileName, raw);

        // file.serviceで画像を取得。aws上のトークンつき画像URLをソースとし表示
        const customSanskritCharacterUrl = result.key;

        this.customSanskritCharacterImg = await usecase.file.fetchURL(result.key);

        this.form.sanskritCharacter = {
          id: "uploadImg",
          sect: "ユーザー選択画像",
          imageUrl: SAMPLE_URL.URLHead + SAMPLE_URL.SANSKRIT_CHARACTER, // constファイル作ってここに直打ち
          inputCode: "",
          imageUrlForTablet: SAMPLE_URL.URLHead + SAMPLE_URL.SANSKRIT_CHARACTER, // constファイル作ってここに直打ち
        };

        this.form = {
          ...this.form,
          customSanskritCharacterUrl,
        };

        // カスタム梵字を有効化
        this.isCustomSanskritCharacter = true;
        // this.sanskritCharacterCards = await false;

        // カスタム梵字選択時、カスタム家紋のURLをnullにする
        this.form.customFamilyEmblemUrl = null;
      } catch (err) {
        console.log(err);

        // Clear file list
        this.$refs.uploadSanskritCharacter.clearFiles();
      }
    },
    onClickDraw (index) {
      this.activeEditorIndex = index;
    },
    onClickChar (char) {
      this.kamonForm.char = char;
      this.getFamilyEMblemTypes(char);
    },
    onClickKamonType (familyEmblemType) {
      this.kamonForm.familyEmblemType = familyEmblemType;
    },
    onCLickKamon (fe) {
      let { familyEmblem } = this.form;
      familyEmblem = JSON.parse(JSON.stringify(fe));

      this.form = { ...this.form, familyEmblem };

      this.kamonForm = {
        char: "",
        familyEmblemType: null,
      };
      // カスタム家紋が入っている場合は初期化
      this.form.customFamilyEmblemUrl = "";
      // カスタム梵字が入っている場合は初期化
      this.form.customSanskritCharacterUrl = null;
      this.isCustomFamilyEmblem = false;
      this.kamonDialogVisible = false;
    },
    onClickOpenKamonModal () {
      this.isCustomFamilyEmblem = false;
      this.kamonDialogVisible = true;
    },
    onClickOpenSanskritCharacterModal () {
      this.isCustomSanskritCharacter = false;
      this.sanskritCharacterDialogVisible = true;
    },
    onClickOpenSanskritCharacterCards () {
      this.isCustomSanskritCharacter = false;
      this.sanskritCharacterDialogVisible = true;
      this.sanskritCharacterCards = true;
      // urlを初期化する
      this.onClickOpenSanskritCharacterCards = "";
    },
    async getFamilyEMblemTypes (char) {
      const kana = [
        { char: "あ", dakuon: [] },
        { char: "い", dakuon: [] },
        { char: "う", dakuon: [] },
        { char: "え", dakuon: [] },
        { char: "お", dakuon: [] },
        { char: "か", dakuon: ["が"] },
        { char: "き", dakuon: ["ぎ"] },
        { char: "く", dakuon: ["ぐ"] },
        { char: "け", dakuon: ["げ"] },
        { char: "こ", dakuon: ["ご"] },
        { char: "さ", dakuon: ["ざ"] },
        { char: "し", dakuon: ["じ"] },
        { char: "す", dakuon: ["ず"] },
        { char: "せ", dakuon: ["ぜ"] },
        { char: "そ", dakuon: ["ぞ"] },
        { char: "た", dakuon: ["だ"] },
        { char: "ち", dakuon: ["ぢ"] },
        { char: "つ", dakuon: ["づ"] },
        { char: "て", dakuon: ["で"] },
        { char: "と", dakuon: ["ど"] },
        { char: "な", dakuon: [] },
        { char: "に", dakuon: [] },
        { char: "ぬ", dakuon: [] },
        { char: "ね", dakuon: [] },
        { char: "の", dakuon: [] },
        { char: "は", dakuon: ["ば", "ぱ"] },
        { char: "ひ", dakuon: ["び", "ぴ"] },
        { char: "ふ", dakuon: ["ぶ", "ぷ"] },
        { char: "へ", dakuon: ["べ", "ぺ"] },
        { char: "ほ", dakuon: ["ぼ", "ぽ"] },
        { char: "ま", dakuon: [] },
        { char: "み", dakuon: [] },
        { char: "む", dakuon: [] },
        { char: "め", dakuon: [] },
        { char: "も", dakuon: [] },
        { char: "や", dakuon: [] },
        { char: "ゆ", dakuon: [] },
        { char: "よ", dakuon: [] },
        { char: "ら", dakuon: [] },
        { char: "り", dakuon: [] },
        { char: "る", dakuon: [] },
        { char: "れ", dakuon: [] },
        { char: "ろ", dakuon: [] },
        { char: "わ", dakuon: [] },
        { char: "を", dakuon: [] },
        { char: "ん", dakuon: [] },
      ];
      const kanaDakuon = kana.find(value => value.char === char);
      const { font } = this.detail.typography;
      const options = {
        q: {
          font,
          nameKanaPrefix: char,
        },
      };
      let familyEmblemTypes = await familyEmblemService.find(options);
      for (let value of kanaDakuon.dakuon) {
        const options = {
          q: {
            font,
            nameKanaPrefix: value,
          },
        };
        const resultDakuon = await familyEmblemService.find(options);
        familyEmblemTypes = familyEmblemTypes.concat(resultDakuon);
      }
      this.familyEmblemTypes = familyEmblemTypes;
    },
  },

  /**
   * [beforeCreate description]
   */
  beforeCreate () {
    usecase.file = new FileUsecase();
    // usecase.orderForm = new OrderFormUsecase();
    usecase.sanskritCharacter = new SanskritCharacterUsecase();
  },

  /**
   * [beforeDestroy description]
   */
  beforeDestroy () {
    Object.keys(usecase).map(key => {
      delete usecase[key];
    });
  },
};

const usecase = {};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.CharCard {
  width: auto;
  min-height: 60px;
  font-size: 25px;
  font-weight: bold;

  border: 1px solid $--border-color-light;
  justify-content: center;
  align-items: center;
  /* displayを廃しテキスト揃え */
  text-align: center;
  line-height: 60px;
}

.CharCard > img {
  width: 100%;
}

.characterCardWrapper {
  margin-top: 0.5rem;
}

.KamonPreview {
  background: black;
  width: 80px;
}

.CustomSanskritCharacterPreview {
  background: black;
  width: 80px;
}

.CharCardInner {
  text-align: center;
  margin: 0;
}

.CharRow {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  margin-bottom: 10px;
  grid-gap: 10px;
}
.CharKana {
  font-size: 14px;
}

.OrderDetailTabContainer > * + * {
  margin-top: 10px;
}
.container {
  display: inline-block;
  position: relative;
}
#buddhist .label {
  text-align: center;
  margin-top: 6px;
}
#characterOptionButton .ButtonGroup {
  margin-right: 22px !important;
  margin-top: 10px !important;
}
.characterOptionBtn {
  width: 70px;
  height: 40px;
}
.characterSankirtBtn {
  width: 100px;
  height: 50px;
}
.characterGroup-Form {
  margin-bottom: 10px;
}
.characherCard-Form {
  width: 84%;
  height: 100%;
  margin-left: 68px;
  margin-top: -10px;
  white-space: nowrap;
}
.choseDefaultButton {
  margin-right: 10px;
}
.characterGroup-Form {
  margin-top: 0;
  margin-left: 0;
  margin-right: 1px;
}
.familyEmblemFormGroup {
  margin-top: 0;
  margin-left: 24px;
  margin-right: 8px;
}
.subLabel {
  margin-right: 58%;
}
.subLabelBuddhistName {
  margin-right: 5%;
}
.subLabelUnderCharacter {
  margin-right: 4%;
}
.Buddhist-Name-Input {
  justify-content: flex-start;
}
.Buddhist-Name-Input-Column {
  width: 220%;
}
</style>
